export const STORAGE_KEY = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  SCROLL: 'scroll',
  VIDEO_USAGE: 'videoUsage',
  OPEN_VIA: 'openVia',
  UN_SENT_MESSAGE: 'unsentMessage',
  VARIANT_KEY: 'variant',
  SHARE_TOKEN: 'shareToken'
};
